var map = {
	"./10C.jpg": 23,
	"./10D.jpg": 24,
	"./10H.jpg": 25,
	"./10S.jpg": 26,
	"./2C.jpg": 27,
	"./2D.jpg": 28,
	"./2H.jpg": 29,
	"./2S.jpg": 30,
	"./3C.jpg": 31,
	"./3D.jpg": 32,
	"./3H.jpg": 33,
	"./3S.jpg": 34,
	"./4C.jpg": 35,
	"./4D.jpg": 36,
	"./4H.jpg": 37,
	"./4S.jpg": 38,
	"./5C.jpg": 39,
	"./5D.jpg": 40,
	"./5H.jpg": 41,
	"./5S.jpg": 42,
	"./6C.jpg": 43,
	"./6D.jpg": 44,
	"./6H.jpg": 45,
	"./6S.jpg": 46,
	"./7C.jpg": 47,
	"./7D.jpg": 48,
	"./7H.jpg": 49,
	"./7S.jpg": 50,
	"./8C.jpg": 51,
	"./8D.jpg": 52,
	"./8H.jpg": 53,
	"./8S.jpg": 54,
	"./9C.jpg": 55,
	"./9D.jpg": 56,
	"./9H.jpg": 57,
	"./9S.jpg": 58,
	"./AC.jpg": 59,
	"./AD.jpg": 60,
	"./AH.jpg": 61,
	"./AS.jpg": 62,
	"./Gray_back.jpg": 6,
	"./JC.jpg": 63,
	"./JD.jpg": 64,
	"./JH.jpg": 65,
	"./JS.jpg": 66,
	"./KC.jpg": 67,
	"./KD.jpg": 68,
	"./KH.jpg": 69,
	"./KS.jpg": 70,
	"./QC.jpg": 71,
	"./QD.jpg": 72,
	"./QH.jpg": 73,
	"./QS.jpg": 74,
	"./aces.jpg": 75
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22;